import { render } from "./AlertSummary.vue?vue&type=template&id=0ab8ef43&scoped=true"
import script from "./AlertSummary.js?vue&type=script&lang=js"
export * from "./AlertSummary.js?vue&type=script&lang=js"

import "./AlertSummary.vue?vue&type=style&index=0&id=0ab8ef43&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab8ef43"]])

export default __exports__